import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { NgxSpinnerService } from "ngx-spinner";
import { ActivatedRoute, NavigationEnd, NavigationStart, Router, RouterEvent } from '@angular/router';
import { AuthConstants } from '../service/config/auth-config';
import { CookieService } from '../service/cookie.service';
import { HttpService } from '../service/http.service';

declare var $: any;
@Component({
    selector: 'app-portal',
    templateUrl: './portal.component.html',
    styleUrls: ['./portal.component.scss']
})
export class PortalComponent implements OnInit, AfterViewInit {
    navActive: any = {};
    active = false;
    cityVal = ' ';
    departVal = ' ';
    userData: any;

    @ViewChild('dropdownAvatar') elDropdownAvatar: ElementRef;

    constructor(
        private router: Router,
        private _vps: ViewportScroller,
        private spinner: NgxSpinnerService,
        private cookieService: CookieService,
        private httpservice: HttpService
    ) {

    }

    ngOnInit(): void {
        this.router.events.subscribe((event: any = RouterEvent) => {
            this.navigationInterceptor(event);
        });

        this.getProfileData();
    }

    getProfileData() {
        const cookie = this.cookieService.getCookie(AuthConstants.AUTH)
        if(cookie) {
            this.httpservice.get("user-info").subscribe(res =>{
                this.userData = res['data'];

                console.log(this.userData);

            });
        }
    }

    navigationInterceptor(event: RouterEvent): void {
        if (event instanceof NavigationStart) {
            this.spinner.show();
        }
        if (event instanceof NavigationEnd) {
            // setTimeout(() => { // here
            //     this.spinner.hide();
            // }, 1000);
            this.spinner.hide();
        }
    }

    scrollFn(anchor: string): void {
        this._vps.scrollToAnchor(anchor);
        this.navActive[anchor] = anchor;
    }

    ngAfterViewInit() {
        $('.ui.accordion').accordion();
        $(this.elDropdownAvatar.nativeElement).dropdown();
    }

    sidemenu() {
        this.active = !this.active;
    }

    logout() {
        this.cookieService.deleteCookie(AuthConstants.AUTH);
        this.router.navigate(['']).then(() => {
            window.location.reload();
        });
      }
}
